export default {
  SHOW_NO_ADS_TOAST: "SHOW_NO_ADS_TOAST",
  SET_GOOGLE_USER_INFO: "SET_GOOGLE_USER_INFO",
  SET_SYNCED_OFFLINE_CONVERSIONS: "SET_SYNCED_OFFLINE_CONVERSIONS",
  GET_ACCOUNT_HIERARCHY: "GET_ACCOUNT_HIERARCHY",
  GET_BUSINESS_INFO: "GET_BUSINESS_INFO",
  GET_GOOGLE_USER_INFO: "GET_GOOGLE_USER_INFO",
  AUTO_LINK_ACCOUNT: "AUTO_LINK_ACCOUNT",
  CHANGE_SETTING_PAGE: "CHANGE_SETTING_PAGE",
  SET_BUSINESS_ADWORDS_ID: "SET_BUSINESS_ADWORDS_ID",
  SET_BUSINESS_ADWORDS_NAME: "SET_BUSINESS_ADWORDS_NAME",
  GET_ADWORDS_CONVERSIONS_DATA: "GET_ADWORDS_CONVERSIONS_DATA",
  GET_ADWORDS_CONVERSIONS_LASTSEND: "GET_ADWORDS_CONVERSIONS_LASTSEND",
  CREATE_OFFLINE_CONVERSION: "CREATE_OFFLINE_CONVERSION",
  GET_LINK_ACCOUNT_STATUS: "GET_LINK_ACCOUNT_STATUS",
  SET_BUSINESS_CAN_ACCESS: "SET_BUSINESS_CAN_ACCESS",
  GET_BUSINESS_PIPELINES: "GET_BUSINESS_PIPELINES",
  GET_BUSINESS_STEPS: "GET_BUSINESS_STEPS",
  GET_ADWORDS_PIPELINE_CONVERSIONS_DATA: "GET_ADWORDS_PIPELINE_CONVERSIONS_DATA",
  CREATE_ADWORDS_PIPELINE_CONVERSIONS_DATA: "CREATE_ADWORDS_PIPELINE_CONVERSIONS_DATA",
  GET_OFFLINE_CONVERSION_ADDON: "GET_OFFLINE_CONVERSION_ADDON",
  UPDATE_OFFLINE_CONVERSION_ADDON: "UPDATE_OFFLINE_CONVERSION_ADDON",
  GET_ACCOUNT_DATA: "GET_ACCOUNT_DATA",
  SET_RWIDGET_CONVERSION_DEFAULT_VALUE: "SET_RWIDGET_CONVERSION_DEFAULT_VALUE",
  GET_LEAD_SOURCE_DATA: "GET_LEAD_SOURCE_DATA",
  GET_GOOGLE_CONVERSION_SET_ALL: "GET_GOOGLE_CONVERSION_SET_ALL",
  SET_GOOGLE_CONVERSION_SET_ALL: "SET_GOOGLE_CONVERSION_SET_ALL",
  GET_GOOGLE_SHEETS_LIST: "GET_GOOGLE_SHEETS_LIST",
  GET_GOOGLE_EXCHANGE_TOKEN: "GET_GOOGLE_EXCHANGE_TOKEN",
  SET_GOOGLE_ACCOUNT: "SET_GOOGLE_ACCOUNT",
  GET_GOOGLE_ACCOUNT: "GET_GOOGLE_ACCOUNT",
  SET_GOOGLE_SHEETS_SETTING: "SET_GOOGLE_SHEETS_SETTING",
  GET_GOOGLE_ADS_LEAD_FORM: "GET_GOOGLE_ADS_LEAD_FORM",
  CHANGE_GOOGLE_ADS_FORM_SELECT_TYPE: "CHANGE_GOOGLE_ADS_FORM_SELECT_TYPE",
  SET_CHECKED_GOOGLE_ADS_FORM_ITEMS: "SET_CHECKED_GOOGLE_ADS_FORM_ITEMS",
  SET_GOOGLE_LEAD_GOOGLE_CONNECTED: "SET_GOOGLE_LEAD_GOOGLE_CONNECTED",
  SET_GOOGLE_LEAD_GOOGLE_DISCONNECTED: "SET_GOOGLE_LEAD_GOOGLE_DISCONNECTED",
  CHANGE_GOOGLE_LEAD_SHEETS_URL_INPUT: "CHANGE_GOOGLE_LEAD_SHEETS_URL_INPUT",
  SET_GOOGLE_ADS_LEAD_FORM_SETTING: "SET_GOOGLE_ADS_LEAD_FORM_SETTING",
  SET_GOOGLE_SHEETS_GG_LEADS_SETTING: "SET_GOOGLE_SHEETS_GG_LEADS_SETTING",
  GET_ALL_GOOGLE_LEAD_FORM_SETTINGS: "GET_ALL_GOOGLE_LEAD_FORM_SETTINGS",
  SWITCH_GOOGLE_LEAD_FORM_STATUS: "SWITCH_GOOGLE_LEAD_FORM_STATUS",
  ARCHIVE_GOOGLE_LEAD_FORM_SETTING: "ARCHIVE_GOOGLE_LEAD_FORM_SETTING",
  GET_GOOGLE_ADS_SETTING: "GET_GOOGLE_ADS_SETTING",
  GET_GOOGLE_SHEETS_SETTING: "GET_GOOGLE_SHEETS_SETTING",
  GET_GOOGLE_LEAD_CRM_SETTING: "GET_GOOGLE_LEAD_CRM_SETTING",
  GET_GOOGLE_LEAD_FORM_SETTING: "GET_GOOGLE_LEAD_FORM_SETTING",
  SET_VALIDATE_GOOGLE_LEAD_FORM: "SET_VALIDATE_GOOGLE_LEAD_FORM",
  SET_VALIDATE_GOOGLE_SHEETS_URL: "SET_VALIDATE_GOOGLE_SHEETS_URL",
  SET_VALIDATE_GG_LEADS_GOOGLE_SHEETS_URL: "SET_VALIDATE_GG_LEADS_GOOGLE_SHEETS_URL",
  SET_DUPLICATE_GOOGLE_FORM: "SET_DUPLICATE_GOOGLE_FORM",
  GET_LEAD_STEPS: "GET_LEAD_STEPS",
  GET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_VALUE: "GET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_VALUE",
  SET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_VALUE: "SET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_VALUE",
  GET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_LAST_SENT: "GET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_LAST_SENT",
  UPDATE_GG_LEAD_FORM_SETTING_ERROR_STATUS: "UPDATE_GG_LEAD_FORM_SETTING_ERROR_STATUS",
  SET_FILE_INFO_ERROR: "SET_FILE_INFO_ERROR",
  SET_GOOGLE_LOADING: "SET_GOOGLE_LOADING",
  SET_GOOGLE_SHEETS_LOADING: "SET_GOOGLE_SHEETS_LOADING",
  SET_GOOGLE_SHEETS_ERROR: "SET_GOOGLE_SHEETS_ERROR",
  SET_GOOGLE_ADS_LOADING: "SET_GOOGLE_ADS_LOADING",
  SET_GG_CONNECTION_LOADING: "SET_GG_CONNECTION_LOADING",
};
